import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capabilitiesJoin',
  standalone: false
})
export class CapabilitiesJoinPipe implements PipeTransform {
  transform(value: any[], separator: string = ', '): string {
    if (!value || !Array.isArray(value)) return '';
    return value.join(separator);
  }
}